import { FormEventHandler, useEffect, useState } from 'react';

import { MAX_NAME_LENGTH } from '~/consts';
import { BottomSheet } from '~/modules/elements/akui/bottom-sheet';
import { InfoButton, InfoLine } from '~/routes/remote-mic/components/info-reveal';

interface Props {
  open: boolean;
  currentName: string;
  onClose: () => void;
  onSave: (name: string) => void;
}

export default function RenameSheet({ open, currentName, onClose, onSave }: Props) {
  const [name, setName] = useState(currentName);

  useEffect(() => {
    if (open) setName(currentName);
  }, [open, currentName]);

  const handleSubmit: FormEventHandler<HTMLFormElement> = (event) => {
    event.preventDefault();
    const trimmed = name.trim();
    if (!trimmed) return;
    onSave(trimmed);
    onClose();
  };

  return (
    <BottomSheet open={open} onClose={onClose} title="Change your name" info={<InfoButton infoKey="Rename" />}>
      <form className="flex flex-col gap-3" onSubmit={handleSubmit}>
        <div className="flex h-16 items-center rounded-[1.125rem] bg-white/8 px-4.5 shadow-[inset_0_0_0_2px_#facc15]">
          <input
            type="text"
            value={name}
            onChange={(event) => setName(event.target.value)}
            maxLength={MAX_NAME_LENGTH}
            placeholder="Enter your name…"
            autoFocus
            data-test="rename-input"
            className="ph-no-capture h-full min-w-0 flex-1 border-none bg-transparent text-[1.375rem] font-bold outline-none"
          />
        </div>
        <InfoLine infoKey="Rename">Scores are matched by name, so keep it the same between games.</InfoLine>
        <button
          type="submit"
          data-test="rename-save-button"
          className="bg-active flex h-16 items-center justify-center rounded-[1.125rem] border-none text-[1.1875rem] font-bold text-black transition-transform duration-100 active:scale-[0.98]">
          Save
        </button>
      </form>
    </BottomSheet>
  );
}
